//
//
//
//
//
//
//
export default {
  name: 'MenuItem',
  props: {
    routerInfo: {
      default: function _default() {
        return null;
      },
      type: Object
    },
    showIcon: {
      default: true,
      type: Boolean
    }
  }
};